<span class="explorerButton" (click)="exportCSV()">
  <b>⬇️ Export CSV</b>
</span>

<div class="m-4">
  <h2 style="font-size: 28px;font-weight: 700;color: #272B30;align-self: flex-start;">Schema Drift Dashboard</h2>
  <p style="color: #6F767E;font-size: 13px;font-weight: 500;align-self: flex-start;">
    <span style="color: #4C94DC;"><b>Stability Index:</b> {{ stabilityIndex }}%</span>
  </p>
  <app-schema-drift-list [driftData]="parsedDriftData"></app-schema-drift-list>
  <app-schema-drift-summary [driftData]="driftDataSummary"></app-schema-drift-summary>
  <app-drift-trend-chart [driftData]="driftDataSummary"></app-drift-trend-chart>
  <app-drift-bar-chart [driftData]="driftDataSummary"></app-drift-bar-chart>
  <app-drift-calendar-heatmap [driftData]="driftDataSummary"></app-drift-calendar-heatmap>
  <app-drift-intensity-matrix [driftData]="driftDataSummary"></app-drift-intensity-matrix>
</div>

<ng-container *ngIf="isPreviewDataSelected">
  <app-preview-data-modal (valueChange)="close($event)"></app-preview-data-modal>
</ng-container>
